import { CircleCheck } from 'lucide-react'
import { Badge } from '@/components/ds2'

/**
 * The one way an invoiced load reads, everywhere a load is shown: a green check, "Invoiced" and its invoice number when it has one.
 * A load with an invoice is invoiced, whatever card drew it, so it never reads "Delivered · INV-…" in one place and "Invoiced" in another.
 */
export const InvoicedLabel = ({ number }: { number?: string | null }) => (
    <span role="status" className="inline-flex">
        <Badge
            variant="soft"
            type="success"
            size="md"
            label={number ? `Invoiced ${number}` : 'Invoiced'}
            prefix={<CircleCheck className="h-3.5 w-3.5" aria-hidden />}
        />
    </span>
)
